/**
 * WebAppDownloadBanner — v1.13.8
 *
 * Bandeau affiché UNIQUEMENT sur le web (react-native-web) pour inviter les
 * visiteurs à télécharger la version mobile via https://www.mytenue.com/app
 * (page smart link qui redirige iOS → App Store / Android → Google Play).
 *
 * - Rendu null sur natif (Platform.OS !== 'web').
 * - Dismissible (mémorisé dans localStorage).
 * - Bilingue FR/EN (getCurrentLang, safe hors I18nProvider).
 */
import React from 'react';
import { View, Text, TouchableOpacity, Platform, Linking } from 'react-native';

const DISMISS_KEY = 'mt_web_dl_banner_dismissed';
const APP_URL = 'https://www.mytenue.com/app';

export default function WebAppDownloadBanner() {
  if (Platform.OS !== 'web') return null;

  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        if (window.localStorage.getItem(DISMISS_KEY) !== '1') setVisible(true);
      }
    } catch (_) {}
  }, []);
  if (!visible) return null;

  let en = false;
  try { en = require('../i18n').getCurrentLang() === 'en'; } catch (_) {}

  const dismiss = () => {
    try { if (typeof window !== 'undefined' && window.localStorage) window.localStorage.setItem(DISMISS_KEY, '1'); } catch (_) {}
    setVisible(false);
  };
  const open = () => {
    try {
      if (typeof window !== 'undefined' && window.open) { window.open(APP_URL, '_blank'); return; }
    } catch (_) {}
    try { Linking.openURL(APP_URL); } catch (_) {}
  };

  return (
    <View style={s.bar} pointerEvents="box-none">
      <View style={s.inner}>
        <Text style={s.emoji}>📱</Text>
        <View style={{ flex: 1 }}>
          <Text style={s.title}>{en ? 'Get MyTenue on mobile' : 'MyTenue sur mobile'}</Text>
          <Text style={s.sub} numberOfLines={1}>
            {en ? 'Virtual try-on, AI looks & more — iOS & Android' : 'Essayage virtuel, looks IA & plus — iOS & Android'}
          </Text>
        </View>
        <TouchableOpacity style={s.cta} onPress={open} activeOpacity={0.85}>
          <Text style={s.ctaText}>{en ? 'Download' : 'Télécharger'}</Text>
        </TouchableOpacity>
        <TouchableOpacity style={s.close} onPress={dismiss} activeOpacity={0.7} hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}>
          <Text style={s.closeText}>×</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const s = {
  bar: {
    position: 'fixed',
    left: 0, right: 0, bottom: 0,
    zIndex: 99998,
    backgroundColor: '#14110D',
    borderTopWidth: 1, borderTopColor: 'rgba(212,175,114,0.45)',
  },
  inner: {
    flexDirection: 'row', alignItems: 'center', gap: 12,
    maxWidth: 760, width: '100%', alignSelf: 'center',
    paddingVertical: 12, paddingHorizontal: 16,
  },
  emoji: { fontSize: 26 },
  title: { color: '#F5F3EE', fontSize: 14, fontWeight: '700', letterSpacing: 0.2 },
  sub: { color: '#CFC8BC', fontSize: 12, marginTop: 1 },
  cta: {
    backgroundColor: '#D4AF72', paddingVertical: 9, paddingHorizontal: 18, borderRadius: 100,
  },
  ctaText: { color: '#14110D', fontSize: 13, fontWeight: '800', letterSpacing: 0.3 },
  close: {
    width: 30, height: 30, borderRadius: 15, alignItems: 'center', justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
  closeText: { color: '#CFC8BC', fontSize: 18, fontWeight: '300', lineHeight: 20 },
};
